import {connect} from 'react-redux';
import SearchBox from '../../components/SearchBox';
import {loadArticles, updateSearch, hasResults, sending, toggleMenu, toggleMobileSearchForm} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    search: state.search.text || ownProps.search,
    searchRequest: state.search.sending,
    gotResults: state.search.hasResults,
    openMobileSearchForm: state.search.openMobileMode
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateSearch: searchTerms => dispatch(updateSearch(searchTerms)),
    loadArticles: (tag, page, search, cb) => dispatch(loadArticles(tag, page, search, cb)),
    hasResults: mode => dispatch(hasResults(mode)),
    sending: mode => dispatch(sending(mode)),
    toggleMenu: mode => dispatch(toggleMenu(mode)),
    toggleMobileSearchForm: mode => dispatch(toggleMobileSearchForm(mode))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SearchBox) as any;
